import { MetricsIcon, LibraryIcon, ComponentsIcon } from "./../assets/icons"
import NavigationLink from "./NavigationLink";


export default function MainNavigation() {
  return (
    <div className="tabRow">
        <div className="tab">
          <NavigationLink icon={<MetricsIcon/>} title="Metrics" address="/metrics"/>
          <NavigationLink icon={<LibraryIcon/>} title="Library" address="/library"/>
          <NavigationLink icon={<ComponentsIcon/>} title="Components" address="/components"/>
        </div>
    </div>
  );
}
